import React from 'react';
import { string, bool, shape } from 'prop-types';
import { Image } from 'components';
import classnames from 'classnames';
import './Brand.scss';

export default function Brand({ className, image, name, cdn, lazyload }) {
    const rootClassnames = classnames(
        'brand',
        {
            'brand--logo-image': !!image && !!cdn,
        },
        className,
    );
    return (
        <div className={rootClassnames}>
            {image && cdn ? (
                <Image
                    className="brand__logo-image"
                    src={image}
                    cdn={cdn}
                    lazyload={lazyload}
                />
            ) : (
                name && <p className="brand__brand-text">{name}</p>
            )}
        </div>
    );
}

Brand.propTypes = {
    className: string,
    image: string.isRequired,
    name: string,
    cdn: shape({
        CDN_IMAGE: string,
    }).isRequired,
    lazyload: bool,
};
Brand.defaultProps = {
    className: null,
    name: null,
    lazyload: false,
};
